import React, { Component } from 'react';
import $ from 'jquery';
import _ from 'lodash';
import fbIcon from '../../../../images/socialIcons/facebook.png';
import { Media } from 'reactstrap';


class MediaComment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            facebookList: sessionStorage.getItem('facebook') ? JSON.parse(sessionStorage.getItem('facebook')) : [],
            setIntervalId: null,
            showCommentReply: false,
            commentReply: '',
            comments: [],
        }
    }

    componentDidMount = () => {
        if (this.state.facebookList && this.state.facebookList.length) {
            let intervalId = setInterval(() => {
                this.state.facebookList.map((facebookPage) => {
                    return this.getFacebookVideoComments(facebookPage);
                })
            }, 30000);
            this.setState({
                setIntervalId: intervalId
            })
        }
    }

    componentWillUnmount = () => {
        clearInterval(this.state.setIntervalId);
    }

    getFacebookVideoComments = (value) => {
        let self = this;
        $.ajax({
            url: "https://graph.facebook.com/v15.0/" + value.streamId + "/comments",
            method: 'GET',
            data: {
                access_token: value.access_token,
            },
            success: (comments) => {
                if(comments && comments.data && !comments.data.length) return comments;
                return this.getFacebookCommentsProfilePic(comments.data, value)
                    .then((updatedComments)=>{
                        if (!value.reactions) value.reactions = {};
                        value.reactions.comments = (updatedComments.length) ? updatedComments : []
                        let updatedFacebookList = _.map(self.state.facebookList, (page) => {
                            if (page.id == value.id)
                                page = value;
                            return page;
                        });
                        self.setState({
                            facebookList: updatedFacebookList
                        })
                    })
            },
            error: function (err) {
                console.error(err);
            }
        })
    }

    getFacebookCommentsProfilePic = (comments, value) => {
        let updateComment = comments.map((comment)=>{
            return new Promise((resolve, reject)=>{
                $.ajax({
                    url: "https://graph.facebook.com/v15.0/" + comment.from.id + "?fields=picture.width(200).height(240)",
                    method: 'GET',
                    data: {
                        access_token: value.access_token,
                    },
                    success: (result) => {
                        if (result.picture) {
                            comment.profilePic = result.picture.data.url
                        }
                        resolve(comment);
                    },
                    error: function (err) {
                        console.error(err);
                    }
                })
            })
        })
        return Promise.all(updateComment);
    }


    changeReplyText = (e) => {
        this.setState({ commentReply: e.target.value });
    }

    replyCommentInputField = (index) => {
        this.setState({ showCommentReply: !this.state.showCommentReply, commentIndex: index })
    }


    sendReplyOnComment = (dest, comment) => {
        console.log(dest, comment)
        $.ajax({
            url: "https://graph.facebook.com/v15.0/" + comment.id + "/comments",
            method: 'POST',
            data: {
                access_token: dest.access_token,
                message: this.state.commentReply
            },
            success: (result) => {
                console.log('oosl',result)
                this.setState({
                    showCommentReply: !this.state.showCommentReply,
                    commentReply: ''
                })
                this.props.notifySuccess("Resposta enviada com sucesso!");
            },
            error: function (err) {
                console.error(err);
            }
        })
    }


    render() {
        return (
            <div className="Stats flex-grow">
                <div className="col-md-12 relay-icons">
                    <button className="btn add-button scheduleButton" onClick={() => { this.props.history.push("/main") }}>
                        <i className="fa fa-plus" aria-hidden="true"></i> Adicionar agendamento</button>
                </div>
                <div>
                <h3 className="col-md-12 dashboard-Title">Comentários do Facebook</h3>
                </div>
                { this.state.facebookList && this.state.facebookList.length ?
                    this.state.facebookList.map((facebookPage, i) => {
                        return (<div key={i}>
                            <Media left tag="span" className="stat-item__platform d-flex flex-column flex-sm-row  align-items-center p-sm-2">
                                <Media object src={facebookPage.profilePic ? facebookPage.profilePic : fbIcon} className="stat-item__platform__img mr-2 fbImageIcon" alt="fb icon" />
                                <span className="stat-item__platform__details d-flex flex-column">
                                    <span className="stat-item__platform__details__name dest-name text-truncate">{facebookPage.name}</span>
                                </span>
                            </Media>
                            <div>
                                {facebookPage.reactions && facebookPage.reactions.comments ? facebookPage.reactions.comments.map((comments, j) => {
                                    return (
                                        <div className="comments" key={j}>
                                            <Media object src={comments.profilePic ? comments.profilePic : fbIcon} className="commentIcon" alt="fb icon" />
                                            <p className="commentProfileName commentMessage">{comments.from ? comments.from.name : ''}</p>
                                            <p className="commentMessage">{comments.message}</p>
                                            <div className="commentLikeReply">
                                                <span className="commentLike">Like</span>
                                                <span className="commentReply" onClick={() => { this.replyCommentInputField(j) }}>Reply</span>
                                                {this.state.showCommentReply && this.state.commentIndex == j ?
                                                    <div>
                                                        <textarea type="text" name="comment" defaultValue={this.state.commentReply} onChange={this.changeReplyText} className="commentReplyText" ></textarea>
                                                        <button className="sendComment" onClick={() => { this.sendReplyOnComment(facebookPage, comments) }}> Send</button>
                                                    </div> :
                                                    null
                                                }
                                            </div>
                                        </div>
                                    )
                                }) : null}
                            </div>
                        </div>)
                    }) : null
                }
            </div>
        )
    }
}
export default (MediaComment);


// WEBPACK FOOTER //
// ./src/components/DashboardPage/Dashboard/mediaComment/MediaComment.js